export default function about() {
  $('#btn-full-bio').click(function(e){
    e.preventDefault();

    $.magnificPopup.open( {
      items: {
        src: '#full-bio-modal .full-bio',
        type: 'inline',
      }
    } );
  });
}